import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  UpdateSalaryStructureGraphQLRequest,
  UpdateSalaryStructureGraphQLResponse,
} from '../types';

const updateSalaryStructureMutation = gql`
  mutation PayrollUpdateSalaryStructure($input: PayrollUpdateSalaryStructureInput!) {
    payrollUpdateSalaryStructure(input: $input) {
      data {
        id
      }
      code
      success
      message
    }
  }
`;

const updateSalaryStructure = (queryVariables: UpdateSalaryStructureGraphQLRequest) => {
  return graphQLApi<UpdateSalaryStructureGraphQLResponse, UpdateSalaryStructureGraphQLRequest>({
    query: updateSalaryStructureMutation,
    queryVariables,
  });
};

export default updateSalaryStructure;
